<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="操作员管理" name="SysAdmin">
        <SysAdmin></SysAdmin>
      </el-tab-pane>
      <el-tab-pane label="权限组" name="PermissMana">
        <PermissMana></PermissMana>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PermissMana from '../../../components/sys/basic/PermissMana'
import SysAdmin from '../../../components/sys/basic/SysAdmin'

export default {
  name: 'SysRole',
  data () {
    return {
      activeName: 'SysAdmin',

    }
  },
  components: {
    PermissMana,
    SysAdmin
  }
}
</script>

<style scoped>

</style>
